import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Image } from '@frontend/core';

@Component({
  selector: 'multisite-gallery-cta',
  templateUrl: './gallery-cta.component.html',
  styleUrls: ['./gallery-cta.component.scss'],

  standalone: false,
})
export class GalleryCtaComponent {

  @Input() titleTranslationKey: string // 'survey.snapshot_heading'
  @Input() titleText: string; // 'Headquarters'
  @Input() descriptionTranslationKey: string // 'common.hq'
  @Input() descriptionText: string; // 'Headquarters'
  @Input() buttonLabelTranslationKey: string // 'common.hq'
  @Input() buttonLabelText: string; // 'Headquarters'
  images = input<Image[]>([]);
  @Input() imageTransformations: string = 'w_350,c_fill,ar_16:9/';
  @Output() linkClicked = new EventEmitter();
  fallbackMedia: Image[];

  constructor() {

    this.fallbackMedia = [
      { id: 0, disk: 'cloudinary', path: 'scenes/banners/man-in-foreground-of-crowd-midjourney-6693f048-5e73-44a1-a1a4-2478d5557046_0.jpg' },
      { id: 0, disk: 'cloudinary', path: 'scenes/banners/woman-in-foreground-of-crowd-midjourney-630c1152-d32f-4aa7-88ed-654447a424ef_3.jpg' },
      { id: 0, disk: 'cloudinary', path: 'scenes/banners/woman-in-foreground-of-crowd-midjourney-1b54e55b-03bc-4ef0-945c-cbbb370b74c6_0.jpg' },
      { id: 0, disk: 'cloudinary', path: 'scenes/banners/man-in-foreground-of-crowd-midjourney-30687212-119a-4f0a-9dcf-c852ea980be0.jpg' },
    ];

  }

  doLinkClick (){

    this.linkClicked.emit();
  }

}
